import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    cardContent: {
        backgroundColor: 'white',
        maxWidth: theme.layout.contentWidth,
        border: theme.border.light,
        borderRadius: 8,
        display: 'block',
        paddingLeft: 30,
    },

    contentMainText: {
        fontSize: '1.125rem',
        textTransform: 'none',
        lineHeight: '1.75rem',
        color: theme.palette.common.darkGrey,
        paddingTop: 30,

        paddingRight: 30,
    },
    emptyClassesImg: {
        width: 248,
        objectFit: 'contain',
        [theme.breakpoints.down('sm')]: {
            width: 252,
            height: 252,
        },
        [theme.breakpoints.down('sm')]: {
            width: 252,
            height: 252,
        },
        [theme.breakpoints.down('xs')]: {
            width: 150,
            height: 150,
        },
    },
}));

const RenderEmpty = ({ mainData }) => {
    const classes = useStyles();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));

    const { t } = useTranslation();

    return (
        <div
            className={classes.cardContent}
            style={{
                marginTop: 23,
            }}
        >
            <Grid container direction={matches ? 'column-reverse' : 'row'}>
                <Grid item md={6} xs={12}>
                    <div style={{ width: '100%' }}>
                        <Typography className={classes.contentMainText} style={{ marginBottom: 13 }}>
                            {t('NoOnlineBookingAvailable')}
                        </Typography>
                    </div>
                </Grid>
                <Grid item md={6} xs={12}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: matches ? 'flex-start' : 'end',
                        }}
                    >
                        <img
                            alt="no professionals found"
                            src={mainData?.discover_others_image1.url}
                            className={classes.emptyClassesImg}
                        />
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

export default RenderEmpty;
